export default {
  translation: {
    "A scheduled task start date has already been assigned in some instance cards:":
      "A scheduled task start date has already been assigned in some instance cards:",
    "Access denied": "Access denied",
    "Action is irreversible": "Action is irreversible",
    "Actual duration": "Actual duration",
    "Actual start date": "Actual start date",
    "Actual end date": "Actual end date",
    Add: "Add",
    "Add points": "Add points",
    "Add version": "Add version",
    Address: "Address",
    "Adding points": "Adding points",
    "Advanced settings": "Advanced settings",
    all: "all",
    "All data will be deleted": "All data will be deleted",
    "Allow import from file": "Allow import from file",
    "Appeal to technical support is registered":
      "Appeal to technical support is registered",
    Amount: "Amount",
    Apply: "Apply",
    "Are you sure to delete {{count}} persons?":
      "Are you sure to delete {{count}} persons?",
    "Are you sure to delete {{count}} persons?_one":
      "Are you sure to delete {{count}} person?",
    "Are you sure to delete version?": "Are you sure to delete version?",
    "Are you sure to delete selected positions?":
      "Are you sure you want to delete the selected items?",
    "Assign a new one for the selected instances":
      "Assign a new one for the selected instances",
    "Attached file": "Attached file",
    "Attached files": "Attached files",
    "Attention!": "Attention!",
    Attributes: "Attributes",
    Attribute: "Attribute",
    'Attributes to display the role "{{role}}"':
      'Attributes to display the role "{{role}}"',
    "Authorization required": "Authorization required",
    "Base size": "Base size",
    "By another attribute value": "By another attribute value",
    "By another attribute value tooltip":
      "The list is limited by the value of the selected attribute",
    "By references (referencing instances only)":
      "By references (referencing instances only)",
    "By references tooltip":
      "The list is limited to instances that reference this instance according selected attribute",
    "Bussiness dictionaries": "Bussiness dictionaries",
    "Calendar plan created": "Calendar plan created",
    Category: "Category",
    Cancel: "Cancel",
    "Cannot select the current model to copy":
      "Cannot select the current model to copy",
    Change: "Change",
    "Change of state": "Change of state",
    "Change password": "Change password",
    "Change state": "Change state",
    "Changing the value of attributes": "Changing the value of attributes",
    ChangingTheStateOfAnInstance_one: "Changing the state of an instance",
    ChangingTheStateOfAnInstance_other: "Changing the state of an instances",
    "Chat list": "Chat list",
    "Checking whether instances have a calendar plan":
      "Checking whether instances have a calendar plan",
    Clear: "Clear",
    "Click or drag the file/s to the area to upload. Downloading from the clipboard is possible.":
      "Click or drag the file/s to the area to upload. Downloading from the clipboard is possible.",
    Close: "Close",
    Color: "Color",
    "Color manual": "Color manual",
    "Color model": "Color model",
    "Color reference": "Color reference",
    "Collapse menu": "Collapse menu",
    "Columns visibility": "Columns visibility",
    Comment: "Comment",
    "Communication between objects is not configured. Contact your administrator.":
      "Communication between objects is not configured. Contact your administrator.",
    "Confirm deletion": "Confirm deletion",
    "Confirm deletion of N instances":
      "Please confirm deletion of {{count}} instances",
    "Confirm deletion of N instances_one":
      "Please confirm deletion of {{count}} instance",
    "Contacting tech support": "Contacting tech support",
    Continue: "Continue",
    "Continue to create a calendar plan?":
      "Continue to create a calendar plan?",
    "Continue without instances": "Continue without instances",
    Copy: "Copy",
    "Copy to": "Copy TO",
    "Copy to another instance from current instance":
      "Copy TO another instance FROM current instance",
    "Copy from": "Copy FROM",
    "Copy from model": "Copy from model",
    "Copy from template": "Copy from template",
    "Copy to another model": "Copy to another model",
    Copying: "Copying",
    "Copying an instance": "Copying an instance",
    "Copying was successful": "Copying was successful",
    Count: "Count",
    Country: "Country",
    Create: "Create",
    "Create a calendar plan": "Create a calendar plan",
    "Create a chat": "Create a chat",
    "Create a task": "Create a task",
    "Create BOM": "Create BOM",
    "Create empty matType": "Create empty {{matType}}",
    "Create from template": "Create from template",
    "Create matType from library": "Create {{matType}} from library",
    "Create request": "Create request",
    "Creating a calendar plan is not possible":
      "Creating a calendar plan is not possible",
    "Creating BOM": "Creating BOM",
    "Creating matType from library": "Creating {{matType}} from library",
    "Current password": "Current password",
    "Current state": "Current state",
    "Customizing the column display": "Customizing the column display",
    Dashboards: "Dashboards",
    "Data not loaded": "Data not loaded",
    "Data updated": "Data update completed",
    "Data will be displayed after saving":
      "Data will be displayed after saving",
    Date: "Date",
    DateFormat: "DD.MM.YYYY",
    DateTimeFormat: "DD.MM.YYYY HH:mm",
    "Delay / override": "Delay / override",
    Delete: "Delete",
    "Delete chat": "Delete chat",
    "Delete selected": "Delete selected",
    "Delete version": "Delete version",
    "Deletion is impossible": "Deletion is impossible",
    "Deletion of tasks": "Deletion of tasks",
    "Deletion task": "Deletion task",
    "Describe the question": "Describe the question",
    Description: "Description",
    Dictionaries: "Dictionaries",
    "Display available only for created instances":
      "Display available only for created instances",
    "Disable entity versioning": "Disable entity versioning",
    Division: "Division",
    "Do you really want to delete the chat ?":
      "Do you really want to delete the chat ?",
    "Do you really want to delete the selected instances?":
      "Do you really want to delete the selected instances?",
    "Do you want to delete the current entry?":
      "Do you want to delete the current entry?",
    "Doesn't match": "Doesn't match",
    "Do you want to delete the selected records?":
      "Do you want to delete the selected records?",
    Done: "Done",
    "Download template": "Download template",
    "Enter a name": "Enter a name",
    "Enter email": "Enter email",
    "Enter the Email you used when registering your account":
      "Enter the email you used to register your account. We will send you a link to reset your password.",
    "Enter information to register on the platform":
      "Enter information to register on the platform",
    "EntityId value not received": "entityId value not received",
    // Пустое значение строки, апперкейс приходит с бэкенда
    EMPTY_VALUE_STRING_WORD: "Empty value",
    Edit: "Edit",
    Entity_one: "Entity",
    Entity_few: "Entities",
    Error: "Error",
    "Error when accessing the server": "Error when accessing the server",
    "Estimated start date": "Estimated start date",
    "Estimated end date": "Estimated end date",
    "Executed instance creation": "Executed instance creation",
    File: "File",
    "File modification": "File modification",
    "Fill in attribute {name}": `Fill in attribute "{{name}}"`,
    "File upload error": "File upload error",
    "File processing may take a long time":
      "File processing may take a long time. Once processing is complete, you will receive a push notification in the system",
    Filter: "Filter",
    "Find an attribute": "Find an attribute",
    Finish: "Finish",
    "Format: value": "Format: {{value}}",
    From: "From",
    "From the template": "From the template",
    "Full name": "Full name",
    "General information": "General information",
    "Groups and roles": "Groups and roles",
    Heading: "Heading",
    "Hierarchy structure": "Hierarchy structure",
    "History of changes": "History of changes",
    Image: "Image",
    "Image modification": "Image modification",
    Import: "Import",
    "Import from file": "Import from file",
    "Import from file is running": "Import from file is running",
    "Import from file will be available again after the current import is completed":
      "Import from file will be available again after the current import is completed",
    "Incorrect current password":
      "The current password you entered is incorrect",
    "Incorrect format of received data": "Incorrect format of received data",
    "Instance of object": "An instance of the {{name}} object",
    "Instructions for working in the system":
      "Instructions for working in the system",
    "Invalid email format": "Invalid email format",
    "Invalid data format:": "Invalid data format for {{file}}",
    "Invalid page URL": "Invalid page URL",
    "Invalid row id in version key": "Invalid row id in version key: {{key}}",
    "Invalid version key": "Invalid version key: {{key}}",
    "Is not selected": "{{parameter}} is not selected",
    "It is required to correctly fill in the fields on the form":
      "It is required to correctly fill in the fields on the form",
    "Keep the current one": "Keep the current one",
    "Letter has been sent": "The letter has been sent",
    "Limit instance list selection:": "Limit instance list selection:",
    Link: "Link",
    Members: "Members",
    Message: "Message",
    Loading: "Loading",
    Location: "Location",
    Login: "Login",
    Logout: "Logout",
    Main: "Main",
    "Main title": "Main",
    Management: "Management",
    "Mark everything as read": "Mark everything as read",
    "Marked by reading": "Marked by reading",
    massCreatePlans: "Mass creation of tasks from a template",
    Material: "Material",
    "Material Type": "Material Type",
    "Maximum number: count": "Maximum number: {{count}}",
    "Maximum total size:": "Maximum total size: {{size}} MB",
    "Menu settings": "Menu Settings",
    "Missing value": "Missing value of {{parameter}}",
    Model: "Model",
    Models: "Models",
    Modify: "Modify",
    "N items deleted": "{{count}} items deleted",
    "N items deleted_one": "{{count}} item deleted",
    Name: "Name",
    "New instance": "New instance",
    "New instance has been created": "A new instance has been created",
    "New instance of object": "A new instance of the {{name}} object",
    "New instances were created": "{{count}} new instances were created",
    "New instances were created_one": "{{count}} new instance were created",
    "New password": "New password",
    "New position": "New position",
    "New task": "New task",
    Next: "Next",
    No: "No",
    "No available states for transition": "No available states for transition",
    "No match for path {path}": "No match for path {path}",
    "No selected points to copy": "No selected points to copy",
    "No object specified": "No object specified",
    "No records selected for copying": "No records selected for copying",
    Notifications: "Notifications",
    "Number of hidden columns": "Number of hidden columns: {{count}}",
    Object: "Object",
    "Objects and attributes": "Objects and attributes",
    OK: "OK",
    Or: "Or",
    Overwrite: "Overwrite",
    "Overwrite measurement chart changes?":
      "Overwrite measurement chart changes?",
    Password: "Password",
    "Password change completed": "Password change completed",
    "Password must contain": "Password must contain",
    "Password recovery": "Password recovery",
    Performer: "Performer",
    "Performer load per task per day": "Performer load per task per day",
    Persons: "Persons",
    Plan: "Plan",
    "Plan template": "Plan template",
    "Planned duration": "Planned duration",
    "Planned start date": "Planned start date",
    "Planned end date": "Planned end date",
    "Please, select a source model and click the Copy button.":
      "Please, select a source model and click the Copy button.",
    "Please, select a template instance and click the Copy button.":
      "Please, select a template instance and click the Copy button.",
    "Point name": "Point name",
    Positions: "Positions",
    "Press Ctrl+Enter/Cmd+Enter to apply":
      "Press Ctrl+Enter/Cmd+Enter to apply",
    "Previous step": "Previous step",
    "Previous task": "Previous task",
    Priority: "Priority",
    "Product article": "Product article",
    "Quality details": "Quality Details",
    Question: "Question",
    "Recalculation of planned dates for tasks":
      "Recalculation of planned dates for tasks",
    "Reference is empty": "{{object}} reference is empty",
    Refresh: "Refresh",
    Register: "Register",
    "Registration of object": "Registration of {{obj}}",
    "Related tasks": "Related tasks",
    Repeat: "Repeat",
    "Repeat new password": "Repeat new password",
    Reset: "Reset",
    "Restore password": "Restore password",
    "Return to the authorization page": "Return to the authorization page",
    Save: "Save",
    "Saving is not possible. Status: {{status}}":
      "Saving is not possible. Status: {{status}}",
    Scale: "Scale",
    "Scaling will change the dimension values relative to the base size.":
      "Scaling will change the dimension values relative to the base size.",
    Search: "Search",
    "Search by name or description": "Search by name or description",
    Send: "Send",
    "Send link": "Send link",
    "Server error": "Server error",
    Setting: "Setting",
    Select: "Select",
    "Select an instance to copy previously selected instances":
      "Select an instance to copy previously selected instances",
    "Select dependent objects to copy": "Select dependent objects to copy:",
    "Selected positions": "Selected positions",
    "Select positions to copy": "Select positions to copy",
    "Select the desired menu item to start operation":
      "Select the desired menu item to start operation",
    "Select the instance to copy": "Select the instance to copy",
    "Select the instances to copy": "Select the instance to copy",
    "Select the instances to copy previously selected instances":
      "Select the instances to copy previously selected instances",
    "Select the instance to which you want to copy the previously selected instances of the linked object with all relationships":
      "Select the instance to which you want to copy the previously selected instances of the linked object with all relationships",
    "Select the instances where to move the copied instances to":
      "Select the instances where to move the copied instances to",
    "Select the source instance to copy": "Select the source instance to copy",
    Selected: "Selected",
    "Select all states": "Select all",
    "Selected states count": "Selected: {{count}}",
    "Unavailable state": "Unavailable state: {{id}}",
    "Selected lines count": "{{count}} lines are selected",
    "Selected lines count_one": "{{count}} line is selected",
    "Selecting a plan template": "Selecting a plan template",
    "Selecting a point": "Selecting a point",
    "Selecting a task group template": "Selecting a task group template",
    "Selecting a task template": "Selecting a task template",
    "Send message": "Send message",
    "Send registration request": "Send registration request",
    "Set default view": "Set default view",
    "Short name": "Short name",
    "Sign In": "Sign In",
    Size: "Size",
    "Size line": "Size line",
    "Size scale": "Size scale",
    "Show filter": "Show filter",
    "Show for the period": "Show for the period",
    "Show Gantt": "Show Gantt",
    "Specify the topic": "Specify the topic",
    "SSO Authorization": "SSO Authorization",
    State: "State",
    "State change performed": "State change performed",
    Status: "Status",
    Step: "Step {{count}}",
    Subject: "Subject",
    Submit: "Submit",
    Summary: "Summary",
    Supplier: "Supplier",
    "System is not ready": "System is not ready",
    "Table export": " Table export",
    Task: "Task",
    "Task bindings associated with the task(s) have been deleted. Scheduled start and end dates of tasks recalculated.":
      "Task bindings associated with the task(s) have been deleted. Scheduled start and end dates of tasks recalculated.",
    "Task deletion completed": "Task deletion completed",
    "Task group": "Task group",
    "Task group / task": "Task group / task",
    "Task group template": "Task group template",
    "Task related task bindings have been removed":
      "Task related task bindings have been removed",
    "Tasks have been deleted.": "Tasks have been deleted.",
    "Task has been deleted.": "Task “{{name}}” has been deleted.",
    "Task is completed": 'Task "{{name}}" is completed!',
    "Task is in progress": 'Task "{{name}}" is in progress!',
    "Tasks selected for deletion": "Tasks selected for deletion",
    "Task template": "Task template",
    "Task was not found": 'Task "{{name}}" was not found!',
    "Task without template": "Task without template",
    "Tech support": "Tech support",
    templates: "templates",
    "The attributes are mandatory when transitioning to this state":
      "The attributes {{attrs}} are mandatory when transitioning to this state",
    "The calendar of these instances has already been created and contains tasks":
      "The calendar of these instances has already been created and contains tasks",
    "The calendar plan cannot be created in some instances because it has already been created and contains tasks":
      "The calendar plan cannot be created in some instances because it has already been created and contains tasks",
    "The deletion will affect scheduled task dates, due to the deletion of task bindings.":
      "The deletion will affect scheduled task dates, due to the deletion of task bindings.",
    "The field is mandatory": "The field is mandatory",
    "The form contains unsaved data. Continue with data loss?":
      "The form contains unsaved data. Continue with data loss?",
    "The instance is missing": "The instance is missing",
    "The instances have been deleted": "The instances have been deleted",
    "The link must start with": "The link must start with http:// or https://",
    "The measurement chart points has been copied successfully":
      "The measurement chart points has been copied successfully",
    "The message contains an attachment": "The message contains an attachment",
    "The state has been deleted": "The state has been deleted",
    "The selected tasks contain tasks in the “In Progress” and/or “Completed” status!":
      "The selected tasks contain tasks in the “In Progress” and/or “Completed” status!",
    "The service has not been configured":
      "The service has not been configured",
    "The dictionary must contain at least one entry":
      "The dictionary {{dict}} must contain at least one entry",
    "There are no messages in the chat": "There are no messages in the chat",
    "There is no user with the specified data":
      "There is no user with the specified data",
    "This file format is not supported": "This file format is not supported",
    TimeFormat: "HH:mm:ss",
    To: "To",
    "To home": "To home",
    Total: "Total",
    "Total files size exceeds": "Total files size exceeds {{size}} MB",
    "Total models: {{count}}": "Total models: {{count}}",
    "Total information": "Total information",
    "Total instances count": "Total instances: {{count}}",
    "Total persons count": "Total {{count}} users",
    "Total persons count_one": "Total {{count}} user",
    "Trim size": "Trim size",
    "Value cleared": "Value cleared",
    Upload: "Upload",
    "Upload a file": "Upload a file",
    User: "User",
    UserAccount: "User account",
    Yes: "Yes",
    "You cannot delete a task.": "You cannot delete a task.",
    "You cannot delete tasks. Select tasks in the “Created” state.":
      "You cannot delete tasks. Select tasks in the “Created” state.",
    "Your request has been registered by the technical support service":
      "Your request has been registered by the technical support service",
    "Wait until saving finishes": "Wait until saving finishes",
    "Welcome to the Omnidata platform!": "Welcome to the Omnidata platform!",
    "When saving, multiple instances of the object will be created":
      'When saving, multiple instances of the "{{obj}}" object will be created, one for each selected "{{attr}}" attribute value.',

    actionType: {
      // see ActionTypeName
      ATTRIBUTE: "Attribute",
      OBJECT: "Object",
      ENTITY: "Instance",
    },
    attrType: {
      ARTICLE: "Article",
      BOOLEAN: "Boolean",
      CHILD_OBJECT_ID: "List of dependent objects",
      DATE: "Date",
      DATE_WITH_TIME: "Date and time",
      OBJECT_ID: "Link to another object",
      ONE_CHOICE_DICTIONARY: "Reference",
      FILE: "File",
      FINANCIAL: "Financial",
      FORMULA: "Formula",
      IMAGE: "Image",
      INT: "Integer",
      LINK_TO_EXTERNAL_SOURCE: "Link to external resource",
      LINKED_VALUE: "Link to value",
      MULTIPLE_CHOICE_DICTIONARY: "Multiple choice from a reference",
      NUMERIC: "Fractional number",
      STRING: "Text",
      SYSTEM_LANGUAGE: "System language",
      TIME: "Time",
      USER_FILTER: "Users list",
    },
    groupType: {
      ByDictionary: "By dictionary",
      Mnemonic: "Mnemonic",
      Dictionary: "Dictionary",
    },
    management: {
      AddGroup: "Add group",
      "Confirm deletion of dictionary group":
        "Are you sure you want to delete the dictionary group?",
      "Confirm deletion of dictionary":
        "Are you sure you want to delete the dictionary?",
      "Deleting a dictionary group": "Deleting a dictionary group",
      "Group name": "Group name",
      "New group of dictionaries": "New group of dictionaries",
      "Wrong group type": "Wrong group type",
    },
    Month3: {
      Jan: "Jan",
      Feb: "Feb",
      Mar: "Mar",
      Apr: "Apr",
      May: "May",
      Jun: "Jun",
      Jul: "Jul",
      Aug: "Aug",
      Sep: "Sep",
      Oct: "Oct",
      Nov: "Nov",
      Dec: "Dec",
    },
    Pages: {
      Plans: "Plans",
      Projects: "Projects",
      Reports: "Reports",
    },
    PasswordProps: {
      "at least N characters": "at least {{count}} characters",
      "contain numbers": "contain numbers {{n}}",
      "uppercase Latin letters": "uppercase Latin letters {{n}}",
      "lowercase Latin letters": "lowercase Latin letters {{n}}",
      "special characters": "special characters",
      "password cannot be the same as login":
        "password cannot be the same as login",
      "Not done": "Not done: {{n}}",
    },
    vaidation: {
      required: "Required field",
    },
  },
};
